import { render, staticRenderFns } from "./discussBox.vue?vue&type=template&id=8a19268e&"
import script from "./discussBox.vue?vue&type=script&lang=js&"
export * from "./discussBox.vue?vue&type=script&lang=js&"
import style0 from "./discussBox.vue?vue&type=style&index=0&id=8a19268e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports